import React  from "react";
import { useParams } from 'react-router-dom';
import BreedingEventForm from "./components/BreedingEventForm";

const EditBreedingEvent = () => {
	const { breedingeventId } = useParams();

	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
      		<BreedingEventForm recordId={breedingeventId ?? 0} mode="edit"/>
	      </div>
	    </div>
    );
};

export default EditBreedingEvent;